<template>
  <header :style="{ position: header_position }">
    <el-row
      :gutter="10"
      class="display-flex"
      style="align-items: center; flex-wrap: wrap"
    >
      <el-col
        :offset="widths <= 1200 ? 3 : 1"
        :xs="11"
        :sm="7"
        :md="6"
        :lg="6"
        :xl="7"
      >
        <div class="display-flex web_icon" v-if="info">
          <div class="imgicon">
            <img
              class="imgicon"
              :src="info.webLogo"
              alt="官网"
              @click="toHome"
            />
          </div>
          <div class="title" style="display:none">
            <p>{{ info.webName }}</p>
            <!-- <p>{{ info.webName2 }}</p> -->
          </div>
        </div>
      </el-col>
      <el-col
        :pull="widths <= 1200 ? (widths <= 760 ? 15 : 11) : 1"
        v-if="widths <= 1200"
        :xs="5"
        :sm="7"
      >
        <i class="el-icon-menu" @click="clickMenu"></i>
        <div v-if="isClick" class="clickMenu">
          <div>
            <div>
              <ul>
                <li
                  v-for="(item, index) in menuList"
                  :key="index"
                  @click="selected(item)"
                >
                  <a :class="{ active: active == item.menuName }">{{
                    item.menuName
                  }}</a>
                  <!-- <router-link
                    :to="item.menuLink"
                    :class="{ active: active == item.menuName }"
                    >{{ item.menuName }}</router-link
                  > -->
                </li>
              </ul>
            </div>
            <div v-if="widths < 750 && user" class="btnss">
              <div class="chinaName">
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="user.chinaName"
                  placement="bottom"
                >
                  {{ user.chinaName2 }}
                </el-tooltip>
              </div>
              <div type="" @click="toBackGround" class="toback">进入后台</div>
              <div type="" @click="tologOut" class="loginbtn">退出</div>
            </div>
            <div class="btnss" v-if="widths < 750 && !user">
              <div type="" class="loginbtn1" @click="login">登录</div>
              <div type="" @click="register" class="register1">注册</div>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :xs="8" :sm="6" :md="13" :lg="13" :xl="11" v-else>
        <ul>
          <li
            v-for="(item, index) in menuList"
            :key="index"
            @click="selected(item)"
          >
            <a :class="{ active: active == item.menuName }">{{
              item.menuName
            }}</a>
            <!-- <router-link
              :to="item.menuLink"
              :class="{ active: active == item.menuName }"
              >{{ item.menuName }}</router-link
            > -->
          </li>
        </ul>
      </el-col>
      <el-col :xs="24" :sm="7" :md="6" :lg="4" :xl="5" v-if="widths > 750">
        <div v-if="user" class="btns">
          <div class="chinaName">
            <el-tooltip
              class="item"
              effect="dark"
              :content="user.chinaName"
              placement="top-start"
            >
              <span>{{ user.chinaName2 }}</span>
            </el-tooltip>
          </div>
          <div type="" @click="toBackGround" class="toback">进入后台</div>
          <div type="" @click="tologOut" class="logoutbtn">
            <img :src="logOut" alt="" />
          </div>
        </div>
        <div class="btns" v-else>
          <div type="" class="loginbtn" @click="login">登录</div>
          <div type="" @click="register" class="register">注册</div>
        </div>
      </el-col>
    </el-row>
  </header>
</template>

<script>
import { getWebConfigDetail, getWebMenuList } from "../http/admin";
import axios from "axios";
export default {
  name: "Header",
  props: {
    bg_color: {
      type: String,
      default: "transparent",
    },
    hover_flag: {
      type: Boolean,
      default: true,
    },
    header_position: {
      type: String,
      default: "fixed",
    },
  },
  data() {
    return {
      active: "首页",
      isClick: false,
      info: null,
      user: null,
      // user: {
      //   chinaName: "就开始考接了...",
      //   chinaName2: "就开始考接了asdfasdfasf",
      // },
      menuList: [],
      widths: document.body.clientWidth,
      logOut: require("../../static/img/head-view/logout.png"),
      titleList: [
        {
          title: "首页",
          link: "/home",
        },
        {
          title: "基础能力平台",
          link: "/basic",
        },
        {
          title: "公共支撑平台",
          link: "/platform", // '/solution'
        },
        {
          title: "产品及应用",
          link: "/application", // '/customer'
        },
        {
          title: "开发者平台",
          link: "/develop", // '/about'
        },
        {
          title: "下载中心",
          link: "/download", // '/about'
        },
        {
          title: "关于我们",
          link: "/about", // '/about'
        },
      ],
      token: window.localStorage.getItem("token"),
    };
  },
  created() {
    this.getWebMenuList();
    this.getUserNames();
  },
  mounted() {
    this.active = this.$route.meta.nav;
    let that = this;
    window.addEventListener("resize", function () {
      return (() => {
        that.widths = document.body.clientWidth;
      })();
    });
    this.getWebConfigDetail();
  },
  methods: {
    getUserNames() {
      axios
        .post(
          "/pts_interface/SecNodeSynergy",
          {},
          {
            headers: {
              methodName: "userSearch",
              token: this.token,
            },
          }
        )
        .then((response) => {
          if (response.data && response.data.data) {
            if (response.data.data.chinaName) {
              if (response.data.data.chinaName.length > 6) {
                response.data.data.chinaName2 = `${response.data.data.chinaName.substr(
                  0,
                  6
                )}...`;
              } else {
                response.data.data.chinaName2 = response.data.data.chinaName;
              }
            } else {
              if (response.data.data.username.length > 6) {
                response.data.data.chinaName = response.data.data.username;
                response.data.data.chinaName2 = `${response.data.data.username.substr(
                  0,
                  6
                )}...`;
              } else {
                response.data.data.chinaName = response.data.data.username;
                response.data.data.chinaName2 = response.data.data.username;
              }
            }

            this.user = response.data.data;
          }else{
            window.localStorage.removeItem("token");
            window.localStorage.removeItem("loginUser");
          }
        });
    },
    selected(item) {
      this.active = item.menuName;
      this.isClick = false;
      if (item.isEdit != 0) {
        this.$router.push(item.menuLink);
      } else {
        window.open(item.menuLink, "_blank");
      }
    },
    toHome() {
      this.$router.push("/home");
      this.active = "首页";
    },
    clickMenu() {
      this.isClick = !this.isClick;
    },
    register() {
      window.location.href = this.info.registerLink;
      // window.open(this.info.registerLink, "_blank");
    },
    login() {
      window.location.href = this.info.loginLink;
      // window.open(this.info.loginLink, "_blank");
    },
    tologOut() {
      window.localStorage.removeItem("token");
      window.localStorage.removeItem("loginUser");
      window.location.reload();
    },
    getWebConfigDetail() {
      getWebConfigDetail()
        .then((res) => {
          // const name = res.webName.split(" ");
          // res.webName1 = name[0];
          // res.webName2 = name[2];
          this.info = res;
          // this.$store.commit("LOGINURL", res.loginLink);
        })
        .catch((err) => {
          this.$message.error(err.message);
        });
    },
    getWebMenuList() {
      getWebMenuList()
        .then((res) => {
          // this.active = res[0].menuName
          // this.$router.push(res[0].menuLink);
          this.menuList = res;
        })
        .catch((err) => {
          this.$message.error(err.message);
        });
    },
    toBackGround() {
      window.open(
        "/secnode/home/dashboard",
        "_blank"
      );
    },
  },
};
</script>

<style lang="scss" scoped>
$white: #ffffff;
// @mixin rim {
//   background: transparent none repeat scroll 0 0;
//   content: "";
//   height: 10px;
//   position: absolute;
//   width: 25px;
//   visibility: hidden;
//   transition: 0.3s ease;
//   opacity: 0;
// }
header {
  background-color: #0e419d;
  color: $white;
  top: 0;
  left: 0;
  z-index: 1999;
  width: 100%;
  height: 44px;
  padding: 10px 0;
  .web_icon {
    min-width: 300px;
    justify-content: flex-start;
    align-items: center;
    .title {
      text-align: left;
      font-size: 16px;
    }
    .imgicon {
      cursor: pointer;
      left: 100px;
      // width: 42px;
      // height: 42px;
      width: 290px;
      height: 48px;
    }
  }
  .el-icon-menu {
    font-size: 30px;
    cursor: pointer;
  }
  ul {
    display: flex;
    align-items: center;
    // flex-wrap: wrap;
    list-style: none;
    li {
      // margin: 0 12px;
      box-sizing: border-box;
      position: relative;
      // line-height: 64px;
      .active {
        color: #ffffff;
        background-color: #5183e4;
        border-radius: 30px;
        background: rgba(255, 255, 255, 0.16);
        &::before {
          visibility: visible;
          opacity: 1;
          left: 0;
        }
        &::after {
          visibility: visible;
          opacity: 1;
          right: 0;
        }
      }
      a {
        cursor: pointer;
        font-size: 14px;
        display: block;
        text-decoration: none;
        box-sizing: border-box;
        color: $white;
        position: relative;
        padding: 4px 20px;

        &.active {
          color: #ffffff;
          background-color: #5183e4;
          border-radius: 30px;
          background: rgba(255, 255, 255, 0.16);
          &::before {
            visibility: visible;
            opacity: 1;
            left: 0;
          }
          &::after {
            visibility: visible;
            opacity: 1;
            right: 0;
          }
        }
        &:hover {
          color: rgba(255, 255, 255, 0.7);
          &::before {
            visibility: visible;
            opacity: 1;
            left: 0;
          }
          &::after {
            visibility: visible;
            opacity: 1;
            right: 0;
          }
        }
      }
    }
  }
  .clickMenu {
    min-width: 180px;
    // min-height: 300px;
    background-color: #0e419d;
    position: fixed;
    left: 55px;
    ul {
      width: 160px;
      display: inline-block;
    }
  }
  .btnss {
    .loginbtn1 {
      width: 60px;
      height: 30px;
      font-size: 14px;
      font-weight: bold;
      color: #ffffff;
      line-height: 30px;
      letter-spacing: 2px;
      cursor: pointer;
      margin: 5px auto;
    }
    .register1 {
      width: 60px;
      height: 30px;
      background-color: #ffffff;
      opacity: 1;
      font-size: 14px;
      line-height: 30px;
      text-align: center;
      font-weight: bold;
      color: #0e419d;
      cursor: pointer;
      margin: 5px auto;
    }
    .chinaName {
      cursor: pointer;
      font-size: 14px;
      color: #ffffff;
      margin: 5px auto;
    }
    .toback {
      width: 80px;
      height: 30px;
      background: #ffffff;
      border-radius: 2px;
      font-size: 14px;
      color: #0e419d;
      line-height: 30px;
      cursor: pointer;
      margin: 5px auto;
    }
  }
  .btns {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    .loginbtn {
      width: 28px;
      height: 20px;
      font-size: 14px;
      color: #ffffff;
      cursor: pointer;
      margin-right: 30px;
    }
    .logoutbtn {
      width: 20px;
      height: 20px;
      margin-left: 20px;
      cursor: pointer;
      img {
        width: 20px;
        height: 20px;
      }
    }
    .register {
      width: 60px;
      height: 30px;
      background: #ffffff;
      border-radius: 2px;
      font-size: 14px;
      color: #0e419d;
      line-height: 30px;
      cursor: pointer;
    }
    .chinaName {
      cursor: pointer;
      font-size: 14px;
      color: #ffffff;
      margin-right: 10px;
    }
    .toback {
      width: 80px;
      height: 30px;
      background: #ffffff;
      border-radius: 2px;
      font-size: 14px;
      color: #0e419d;
      line-height: 30px;
      cursor: pointer;
    }
  }
}

// 动画
@keyframes shine {
  from {
    background-position: 130%;
  }
  to {
    background-position: -50%;
  }
}

@media only screen and (max-width: 1400px) {
  header{
    ul li a {
      padding: 4px 16px;
    }
    .btns .toback {
      font-size: 12px
    }
  }
}
@media only screen and (max-width: 1260px) {
  header ul li a {
    padding: 4px 13px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue